'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: ', ';\n  ', ';\n  ', ';\n'], ['\n  width: 100%;\n  padding: ', ';\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding: ', ';\n  '], ['\n    padding: ', ';\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _media = require('../../../libs/media');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles
// Libs


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var flat = _ref.flat;
  return flat ? '0px' : '0px 30px';
}, (0, _polished.clearFix)(), _media.media.s(_templateObject2, function (_ref2) {
  var flat = _ref2.flat;
  return flat ? '0px' : '0px 10px';
}));

exports.default = Container;